module.exports = __webpack_public_path__ + "img/NXN1.b1a8a8be.png";